
const search = (searchText, list, searchFields = []) => {
    if (searchText.trim() === "") {
        return list;
    }
    else {
        return list.filter(itemData => {
            const searchTerms = searchText.split(" ");
            return searchTerms.every(term => {
                const re = new RegExp(term, "i");
                return searchFields.some(fieldName => {
                    const field = itemData[fieldName];
                    if (typeof(field) === "string" && re.test(field)) {
                        return true;
                    }
                    else if (Array.isArray(field) && field.some(meta => re.test(meta))) {
                        return true;
                    }
                    else if (typeof(field) === "object") {
                        return Object.values(field).some(value => re.test(value));
                    }
                });
            });
        });
    }
}

export { search }